import { render, staticRenderFns } from "./largeWater_tlf.vue?vue&type=template&id=71a8c75e&scoped=true"
import script from "./largeWater_tlf.vue?vue&type=script&lang=js"
export * from "./largeWater_tlf.vue?vue&type=script&lang=js"
import style0 from "./largeWater_tlf.vue?vue&type=style&index=0&id=71a8c75e&lang=scss&scoped=true"
import style1 from "./largeWater_tlf.vue?vue&type=style&index=1&id=71a8c75e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8c75e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a8c75e')) {
      api.createRecord('71a8c75e', component.options)
    } else {
      api.reload('71a8c75e', component.options)
    }
    module.hot.accept("./largeWater_tlf.vue?vue&type=template&id=71a8c75e&scoped=true", function () {
      api.rerender('71a8c75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeWater_tlf.vue"
export default component.exports